import axios from 'axios';
import { ORGANISATION_API } from 'Constants';
import { OrganisationEntity } from 'Models/Entities';

export async function getAllOrganisations(): Promise<OrganisationEntity[]> {
	const response = await axios.get(`${ORGANISATION_API}/get-all-organisations`);
	return response.data as OrganisationEntity[];
}
